<div class="modal-header">
  <h4 class="modal-title fw-normal">Approve Sale</h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  ></button>
</div>
<div class="modal-body">
  <div class="alert alert-warning" role="alert">
    Are you sure you want to approve this sale? This action will lock editing and cannot be undone.
  </div>

  <form [formGroup]="confirmForm" (ngSubmit)="onSubmit()">
    <div class="mb-3 position-relative">
      <label for="dateSold" class="form-label">
        Date Sold: <span class="text-danger">*</span>
      </label>
      <input
        type="text"
        readonly
        class="form-control"
        id="dateSold"
        placeholder="Select date"
        (click)="toggleDatePicker()"
        [value]="(confirmForm.getRawValue().dateSold | date: 'MM/dd/yyyy') || ''"
        [class.is-invalid]="hasError('dateSold')"
        [disabled]="isDateDisabled"
        [style.cursor]="isDateDisabled ? 'not-allowed' : 'pointer'"
      />
      <div
        class="datepicker-dropdown position-absolute bottom-100 start-0 mb-1 bg-white border rounded shadow-lg fw-normal fs-6"
        *ngIf="showDatePicker && !isDateDisabled"
        (click)="$event.stopPropagation()"
        (keydown.escape)="showDatePicker = false"
        tabindex="-1"
      >
        <groundworks-date-picker
          [selectedDate]="confirmForm.getRawValue().dateSold ?? undefined"
          (fromDateEvent)="onDateChange($event)"
          [displayMonths]="1"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [markDisabled]="markDisabled"
        />
      </div>
      @if (hasError('dateSold')) {
        <div class="invalid-feedback d-block">Date sold is required.</div>
      }
    </div>
  </form>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-primary"
    (click)="onCancel()"
    [disabled]="isSubmitting"
  >
    No, Go Back
  </button>
  <groundworks-loading-button
    (click)="onSubmit()"
    (keydown.enter)="onSubmit()"
    [label]="'Yes, Approve Sale'"
    [disabled]="isSubmitting"
    [loading]="isSubmitting"
  />
</div>
